import React, { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import './LanguageSwitcher.css';

function LanguageSwitcher() {
  const { i18n } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const switcherRef = useRef(null);

  const languages = [
    { code: 'ru', name: 'Русский' },
    { code: 'en', name: 'English' },
    { code: 'de', name: 'Deutsch' },
    { code: 'lt', name: 'Lietuvių' },
  ];

  const currentLanguage = languages.find(lang => lang.code === i18n.language) || languages[0];


  useEffect(() => {
    const handleClickOutside = (event) => {
      if (switcherRef.current && !switcherRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [switcherRef]);

  const handleLanguageChange = (langCode) => {
    i18n.changeLanguage(langCode);
    setIsOpen(false);
  };


  return (

    <div className="language-switcher-dropdown" ref={switcherRef}>
      <button className="current-language-btn" onClick={() => setIsOpen(!isOpen)}>

        <span>{currentLanguage.code.toUpperCase()}</span>

        <span className={`arrow ${isOpen ? 'up' : 'down'}`}></span>
      </button>


      {isOpen && (
        <ul className="language-dropdown-list" style={{
          position: 'fixed',
          top: '80px',
          right: '20px',
          listStyle: 'none',
          padding: '5px',
          margin: '0',
          borderRadius: '8px',
          width: '125px',
          zIndex: 99999,
          backgroundColor: 'rgba(51, 51, 51, 0.95)',
          border: '1px solid rgba(255, 255, 255, 0.2)',
          display: 'block',
          boxSizing: 'border-box',
          boxShadow: '0 4px 20px rgba(0, 0, 0, 0.3)',
          backdropFilter: 'blur(10px)'
        }}>
          {languages
            .filter(lang => lang.code !== currentLanguage.code) // 
            .map(lang => (
              <li key={lang.code}>
                <button
                  onClick={() => handleLanguageChange(lang.code)}
                  onMouseEnter={(e) => e.target.style.backgroundColor = 'rgba(255, 255, 255, 0.1)'}
                  onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
                  style={{
                    backgroundColor: 'transparent',
                    border: 'none',
                    color: '#ffffff',
                    padding: '5px 8px',
                    width: '100%',
                    textAlign: 'left',
                    cursor: 'pointer',
                    fontSize: '12px',
                    borderRadius: '4px',
                    fontWeight: 'bold',
                    transition: 'background-color 0.2s ease'
                  }}>
                  {lang.name}
                </button>
              </li>
            ))}
        </ul>
      )}
    </div>
  );
}

export default LanguageSwitcher;